import { useState, useEffect, useCallback, useMemo } from "react";
import { SimpleGrid, FormLabel } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Loading from "../../../Component/Loading/loading";
import apiService from "../../../Method/Report/Report_Service";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../../assets/Table/TableTheme";
import { t } from "i18next";
import { useDataContext } from "./../../../DataProvider";
import TableWidget from "../../../Component/Table/TableWidget";

const buildColumns = () => [
  {
    name: "IVC_NAME",
    label: t("TYPE"),
    options: { filter: false, sort: false },
  },
  {
    name: "PERCENTAGE",
    label: t("PERCENTAGE"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? `${value}%` : "0%";
      },
    },
  },
  {
    name: "TOTAL_SALES",
    label: t("TOTAL_SALES"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },

  }
];

function App() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const { trigger } = useDataContext();
  const [searchText, setSearchText] = useState("");


  const columns = useMemo(() => buildColumns(t), [t]);
  const [searchColumns, setSearchColumns] = useState(() =>
    columns.filter((c) => c.options?.search !== false).map((c) => c.name)
  );
  useEffect(() => {
    setSearchColumns(columns.filter((c) => c.options?.search !== false).map((c) => c.name));
  }, [columns]);


  const fetchData = useCallback(async () => {

    setLoading(true);
    const { success, data, error } = await apiService.search("GET_IVC_SALES_REPORT", page + 1, rowsPerPage);

    if (success && data) {
      setLoading(false);
      setData(data);
      setError("")
      setTotalCount(data.TOTAL_COUNT || 0);

    } else {
      setError(error.response.data.message);
      setLoading(false);
    }

  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchData()
  }, [trigger, fetchData]);



  const filteredData = (data?.IVC_DETAILS || []).filter((row) => {
    const q = (searchText || "").toLowerCase().trim();
    if (!q) return true;
    return searchColumns.some((name) =>
      row?.[name]?.toString().toLowerCase().includes(q)
    );
  });
  return (
    <ThemeProvider theme={theme}>

      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      <div>
        {!isLoading && (
          <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }}>
            <SimpleGrid
              className="Total_Header"

              columns={{ base: 1 }}
            >


              <div>
                <FormLabel className="Total_Header_Left" >
                  {t("TOTAL_SALES")}
                </FormLabel>
                <FormLabel
                  className="Total_Header_Value"

                >
                  {data.TOTAL_SALES_ALL ? data.TOTAL_SALES_ALL.toLocaleString() : "0"}
                </FormLabel>
              </div>
            </SimpleGrid>
            <TableWidget
              title={t("IVC_SALES_REORT")}
              data={filteredData}
              onSearchChange={setSearchText}
              columns={columns}
              totalCount={totalCount}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setRowsPerPage}
                            searchColumns={searchColumns}
              setSearchColumns={setSearchColumns}
            />

          </div>
        )}
      </div>
    </ThemeProvider >
  );
}

export default App;
